import React from "react";

const TextField = ({
  placeholder,
  field,
  name,
  id,
  onChange,
  label,
  errorMessage = "*This field is required",
  type = "text",
  inputmode = ""
}) => {
  return (
    <div className="form__wrapper">
      {label && (
        <label htmlFor={id} className="form__label">
          {label}
        </label>
      )}
      <input
        type={type}
        id={id}
        name={name}
        placeholder={placeholder}
        className={`form__input ${field.showError ? "form__input--error" : ""}`}
        value={field.value}
        onKeyUp={evt => onChange(evt.target.value, name)}
        inputmode={inputmode}
        formNoValidate="true"
      />
      {field.showError && (
        <p className="form__copy form__copy--error">{errorMessage}</p>
      )}
    </div>
  );
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/_common/Form/inputs/TextField.js